import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
export function AdminScorecards({ eventId }: { eventId: string }) {
  const q = useQuery({
    queryKey: ['admin-scorecards', eventId],
    queryFn: () =>
      api.get<{
        scorecards: {
          personId: string;
          firstName: string;
          lastName: string;
          letter: string;
          sightNose: number | null;
          taste: number | null;
          overall: number | null;
          total: number | null;
          notes: string | null;
        }[];
      }>(`/events/${eventId}/scorecards`),
    refetchInterval: 5000,
  });
  return (
    <details className="card">
      <summary>Administrator: individual scorecards and notes</summary>
      {q.error && <p>{q.error.message}</p>}
      {q.data?.scorecards.map((s) => (
        <p className="my-3" key={`${s.personId}-${s.letter}`}>
          <strong>
            {s.firstName} {s.lastName} · Wine {s.letter}
          </strong>{' '}
          · {s.sightNose ?? '—'} + {s.taste ?? '—'} + {s.overall ?? '—'} = {s.total ?? '—'}
          <br />
          {s.notes}
        </p>
      ))}
    </details>
  );
}
